module.exports = __webpack_public_path__ + "img/dept-8.4a65cc4e.svg";